import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Checkbox, Row, Space, Table } from "antd";

import { DndContext } from "@dnd-kit/core";
import {
	arrayMove,
	SortableContext,
	useSortable,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Swal from "sweetalert2";

import partnersApi from "../../../apis/Partners.api";
import AddProductModal from "../AddProductModal";

const EditDefaultProductComponent = ({
	selectKey,
	productList,
	setProductList,
	level,
}) => {
	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);

	const [modalShow, setModalShow] = useState(false);
	const [modalType, setModalType] = useState("");

	const [selectProduct, setSelectProduct] = useState({});
	const [editIdx, setEditIdx] = useState(0);

	const DraggableRow = ({ children, ...props }) => {
		const {
			attributes,
			listeners,
			setNodeRef,
			setActivatorNodeRef,
			transform,
			transition,
			isDragging,
		} = useSortable({
			id: props["data-row-key"],
		});
		const style = {
			...props.style,
			transform: CSS.Transform.toString(
				transform && {
					...transform,
					scaleY: 1,
				}
			)?.replace(/translate3d\(([^,]+),/, "translate3d(0,"),
			transition,
			...(isDragging
				? {
						position: "relative",
						zIndex: 1,
				  }
				: {}),
		};
		return (
			<tr {...props} ref={setNodeRef} style={style} {...attributes}>
				{React.Children?.map(children, (child) => {
					if (child?.key === "sort") {
						return React.cloneElement(child, {
							children: (
								<img
									src={`/assets/images/hamburger-icon-gray.png`}
									alt={`햄버그 아이콘`}
									style={{
										width: "1.5em",
										height: "auto",
										cursor: "pointer",
										// touchAction: "none"
									}}
									ref={setActivatorNodeRef}
									{...listeners}
								/>
							),
						});
					}
					return child;
				})}
			</tr>
		);
	};

	const onDragEnd = ({ active, over }) => {
		if (active.id !== over?.id) {
			setProductList((previous) => {
				const activeIndex = previous.findIndex(
					(i) => i.product_brand_name_key === active.id
				);
				const overIndex = previous.findIndex(
					(i) => i.product_brand_name_key === over?.id
				);
				return arrayMove(previous, activeIndex, overIndex);
			});
		}
	};

	const handleBestCheck = (e, idx) => {
		let check = e.target.checked;
		let list = [...productList];
		list[idx] = {
			...list[idx],
			is_best: check,
		};
		setProductList(list);
	};

	const columns = [
		{
			key: "sort",
			width: 40,
		},
		{
			title: "베스트",
			dataIndex: "is_best",
			key: "is_best",
			ellipsis: true,
			width: 80,
			render: (value, record, idx) => {
				return (
					<Checkbox
						onChange={(e) => handleBestCheck(e, idx)}
						checked={value}
						disabled={level === "combination"}
					/>
				);
			},
		},
		{
			title: "브랜드명",
			dataIndex: "brand_name",
			key: "brand_name",
			ellipsis: true,
			width: 100,
		},
		{
			title: "제품명",
			dataIndex: "product_name",
			key: "product_name",
			ellipsis: true,
			width: 160,
		},
		{
			title: "상품 설명",
			dataIndex: "sub_title",
			key: "sub_title",
			ellipsis: true,
		},
		// {
		//     title: "특징",
		//     dataIndex: 'sub_title',
		//     key: 'sub_title',
		//     ellipsis: true,
		// },
		{
			title: "",
			dataIndex: "",
			key: "",
			width: 120,
			render: (value, item, idx) => {
				return (
					<Row align={"middle"} justify={"center"} style={{ gap: "5px" }}>
						<Button
							value={value}
							size={`small`}
							style={{ padding: "0 4px" }}
							onClick={() => {
								setSelectProduct({
									...value,
									// category_id: selectKey.ingredient_id,
									// category_name: selectKey.ingredient_name
								});
								setModalShow(true);
								setModalType("edit");
								setEditIdx(idx);
							}}
							loading={isLoading}
						>
							<span style={{ fontSize: "0.9em" }}>수정</span>
						</Button>
						<Button
							size={`small`}
							style={{ padding: "0 4px" }}
							onClick={() => {
								deleteProduct(idx, item);
								// deleteProduct(value);
								// productList.splice(idx, 1);
							}}
							loading={isLoading}
						>
							<span style={{ fontSize: "0.9em" }}>삭제</span>
						</Button>
					</Row>
				);
			},
		},
	];

	// console.log(productList, selectProduct);
	// const rowSelection = {
	//     onChange: (selectedRowKeys, selectedRows) => {
	//         console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
	//     },
	//     getCheckboxProps: (record) => ({
	//         disabled: record.product_name === 'Disabled User',
	//         // Column configuration not to be checked
	//         product_name: record.product_name,
	//     }),
	// };

	useEffect(() => {
		if (selectKey?.ingredient_id) {
			// 성분
			getProductList(selectKey);
		} else if (selectKey?.category_type === "combination") {
			// 조합
			if (selectKey?.productList?.length > 0) {
				// 추천 영양제 sorting 하기 위한 키 생성
				for (const resultEl of selectKey.productList) {
					resultEl[
						"product_brand_name_key"
					] = `${resultEl.brand_name}-${resultEl.product_name}`;
				}
				setProductList(selectKey?.productList);
			} else {
				setProductList([]);
			}
		} else {
			setProductList([]);
		}
	}, [selectKey]);

	/**
	 * 성분별 일때 카테고리 아이디에 해당하는 상품리스트 가져오기
	 * @param selectKey
	 * @returns {Promise<void>}
	 */
	const getProductList = async (selectKey) => {
		let param = {
			categoryId: selectKey?.ingredient_id,
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const res = await partnersApi.readCategoryProductsList(param);
		if (res.code === 200) {
			// 추천 영양제 sorting 하기 위한 키 생성
			for (const resultEl of res.result) {
				resultEl[
					"product_brand_name_key"
				] = `${resultEl.brand_name}-${resultEl.product_name}`;
			}
			setProductList(res.result);
		} else {
			setProductList([]);
		}
	};

	/**
	 * 추천 상품 삭제
	 * @returns {Promise<void>}
	 */
	const deleteProduct = async (idx, item) => {
		if (item?.related_combination) {
			console.log("[deleteProduct] 조합에 연관되어 있음!!!");
			Swal.fire({
				customClass: "alert-custom",
				text: `해당 상품은\n[${item?.relatedCombinationName}]\n조합에도 등록되어 있습니다.\n\n상품을 삭제하시려면 등록된 조합 \n전체에서 해당 상품을 삭제하신 후에 \n다시 시도해주세요.`,
				showCancelButton: false,
				confirmButtonText: "확인",
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: `해당 상품을 삭제하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setEditIdx(idx);
					let list = [...productList];
					list.splice(idx, 1);
					setProductList(list);
				}
			});
		}
	};

	return (
		<div className={`body-default-each`}>
			<p className={`body-each-title`}>
				추천 영양제
				<span className={`required`} />
			</p>
			{productList?.length ? (
				<DndContext onDragEnd={onDragEnd}>
					<SortableContext
						// rowKey array
						items={productList?.map((i) => i?.product_brand_name_key)}
						strategy={verticalListSortingStrategy}
					>
						<Table
							className={`channel-edit-table`}
							components={{
								body: {
									row: DraggableRow,
								},
							}}
							rowKey="product_brand_name_key"
							columns={columns}
							dataSource={productList}
							size={`small`}
							pagination={false}
						/>
					</SortableContext>
				</DndContext>
			) : (
				<Table
					className={`channel-edit-table`}
					components={{
						body: {
							row: DraggableRow,
						},
					}}
					rowKey="product_brand_name_key"
					columns={columns}
					dataSource={productList}
					size={`small`}
					pagination={false}
				/>
			)}
			<Button
				size={"small"}
				className={`edit-gray-btn`}
				style={{
					// borderRadius: "5px",
					// width: "50%",
					margin: "1em auto",
					padding: "0.3em 1.5em",
					height: "auto",
				}}
				loading={isLoading}
				onClick={() => {
					setModalShow(true);
					setModalType("add");
				}}
				disabled={
					!selectKey || (!!selectKey && !Object.keys(selectKey)?.length)
				}
			>
				<img
					src={`/assets/images/channel/plus-circle.png`}
					alt={`관련 성분 추가하기`}
					style={{
						width: "auto",
						height: "1em",
					}}
				/>
				상품 추가하기
			</Button>
			{modalShow && (
				<AddProductModal
					modalShow={modalShow}
					setModalShow={setModalShow}
					selectKey={selectKey}
					type={modalType}
					selectProduct={selectProduct}
					getProductList={getProductList}
					productList={productList}
					setProductList={setProductList}
					index={editIdx}
					level={level}
				/>
			)}
		</div>
	);
};

export default EditDefaultProductComponent;
